<template>
  <div class="memberinvoiceinsight-page page-wrapper">
    <div class="container-fluid">
      <div
        class="memberinvoice_headercontainer d-flex align-items-end justify-content-between flex-wrap gap-2"
      >
        <div class="left-content">
          <breadcrumb :items="breadcrumbItems" />
          <div class="page-title">
            <h1>Member Invoice Insights</h1>
          </div>
        </div>
      </div>
      <div class="row mt-4 mb-4">
        <div class="col-lg-4 col-md-6">
          <div class="memberinsight_summarycard">
            <div class="content-wrap">
              <div class="left-content">
                <div class="title">Unpaid Invoice</div>
                <div class="value">{{ totalPremium || '$0.00' }}</div>
              </div>
              <div class="right-content">
                <div class="icon-wrap">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    viewBox="-2 -3 24 24"
                  >
                    <path
                      fill="currentColor"
                      d="m12.8 1.613l6.701 11.161c.963 1.603.49 3.712-1.057 4.71a3.2 3.2 0 0 1-1.743.516H3.298C1.477 18 0 16.47 0 14.581c0-.639.173-1.264.498-1.807L7.2 1.613C8.162.01 10.196-.481 11.743.517c.428.276.79.651 1.057 1.096m-2.22.839a1.077 1.077 0 0 0-1.514.365L2.365 13.98a1.17 1.17 0 0 0-.166.602c0 .63.492 1.14 1.1 1.14H16.7c.206 0 .407-.06.581-.172a1.164 1.164 0 0 0 .353-1.57L10.933 2.817a1.1 1.1 0 0 0-.352-.365zM10 14a1 1 0 1 1 0-2a1 1 0 0 1 0 2m0-9a1 1 0 0 1 1 1v4a1 1 0 0 1-2 0V6a1 1 0 0 1 1-1"
                    />
                  </svg>
                </div>
              </div>
            </div>
            <div class="invoicetotal">{{ paginationMeta.total || 0 }} invoices · Not in commission</div>
          </div>
        </div>
      </div>

      <div class="row memberinvoiceinsight-card">
        <div class="memberinvoiceinsight-filters">
          <div class="search-container">
            <input
              v-model="search"
              type="text"
              class="form-control"
              placeholder="Search Rep Name"
            />
            <div class="icon-wrap">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24"><path fill="currentColor" d="M18 10c0-4.41-3.59-8-8-8s-8 3.59-8 8s3.59 8 8 8c1.85 0 3.54-.63 4.9-1.69l5.1 5.1L21.41 20l-5.1-5.1A8 8 0 0 0 18 10M4 10c0-3.31 2.69-6 6-6s6 2.69 6 6s-2.69 6-6 6s-6-2.69-6-6"/></svg>
            </div>
          </div>
          <QuickDropdownFilter
            label="Date"
            :options="dateOptions"
            :modelValue="datefilterType"
            @update:modelValue="datefilterType = $event"
          />

          <button
            class="clear-btn d-flex align-items-center gap-1"
            @click="clearFilters"
          >
            <span
              class="icon-wrap d-flex align-items-center justify-content-center"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                viewBox="0 0 24 24"
              >
                <path
                  fill="currentColor"
                  d="M18.36 19.78L12 13.41l-6.36 6.37l-1.42-1.42L10.59 12L4.22 5.64l1.42-1.42L12 10.59l6.36-6.36l1.41 1.41L13.41 12l6.36 6.36z"
                />
              </svg>
            </span>
            Clear
          </button>
        </div>
        <div class="top-pagination p-0">
          <IhaPagination :rows="paginationMeta" @page-change="handlePageChange" />
        </div>
        <!-- TABLE -->
        <div class="table-responsive p-0">
          <table class="table planswitchhistory-table">
            <thead>
              <tr>
                <th>System ID</th>
                <th>Effective Date</th>
                <th>Invoice Details</th>
                <th>Primary Member</th>
                <th>Plan</th>
                <th>Tier</th>
                <th>Rep</th>
                <th>Payment Status</th>
                <th>Reason</th>
                <th>Premium</th>
              </tr>
            </thead>

            <tbody>
              <template v-if="loading">
                <tr v-for="n in perPage" :key="'skel-' + n" class="skeleton-row">
                  <td><span class="skeleton-cell" style="width:80px"></span></td>
                  <td><span class="skeleton-cell" style="width:72px"></span></td>
                  <td>
                    <span class="skeleton-cell" style="width:110px"></span>
                    <span class="skeleton-cell mt-1" style="width:90px"></span>
                  </td>
                  <td>
                    <span class="skeleton-cell" style="width:100px"></span>
                    <span class="skeleton-cell mt-1" style="width:130px"></span>
                    <span class="skeleton-cell mt-1" style="width:110px"></span>
                  </td>
                  <td><span class="skeleton-cell" style="width:140px"></span></td>
                  <td><span class="skeleton-cell" style="width:30px"></span></td>
                  <td><span class="skeleton-cell" style="width:90px"></span></td>
                  <td><span class="skeleton-cell" style="width:70px"></span></td>
                  <td><span class="skeleton-cell" style="width:110px"></span></td>
                  <td><span class="skeleton-cell" style="width:55px"></span></td>
                </tr>
              </template>
              <tr v-for="item in invoices" v-else :key="item.systemId">
                <td>{{ item.systemId }}</td>

                <td>{{ item.effectiveDate }}</td>

                <td>
                  <div class="fw-semibold">{{ item.invoiceMonth }}</div>
                  <div class="txt-small">Bill date: {{ item.billDate }}</div>
                </td>

                <td>
                  <div class="fw-semibold">{{ item.member }}</div>
                  <div class="txt-small">
                    <span class="icon"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24"><path fill="currentColor" d="M22 6c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2zm-2 0l-8 5l-8-5zm0 12H4V8l8 5l8-5z"/></svg></span>
                    {{ item.email }}</div>
                  <div class="txt-small">
                    <span class="icon">
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24"><path fill="currentColor" d="m16.1 13.359l-.528-.532zm.456-.453l.529.532zm2.417-.317l-.358.66zm1.91 1.039l-.358.659zm.539 3.255l.529.532zm-1.42 1.412l-.53-.531zm-1.326.67l.07.747zm-9.86-4.238l.528-.532zM4.002 5.746l-.749.042zm6.474 1.451l.53.532zm.157-2.654l.6-.449zM9.374 2.86l-.601.45zM6.26 2.575l.53.532zm-1.57 1.56l-.528-.531zm7.372 7.362l.529-.532zm4.567 2.394l.455-.453l-1.058-1.064l-.455.453zm1.985-.643l1.91 1.039l.716-1.318l-1.91-1.038zm2.278 3.103l-1.42 1.413l1.057 1.063l1.42-1.412zm-2.286 1.867c-1.45.136-5.201.015-9.263-4.023l-1.057 1.063c4.432 4.407 8.65 4.623 10.459 4.454zm-9.263-4.023c-3.871-3.85-4.512-7.087-4.592-8.492l-1.498.085c.1 1.768.895 5.356 5.033 9.47zm1.376-6.18l.286-.286L9.95 6.666l-.287.285zm.515-3.921L9.974 2.41l-1.201.899l1.26 1.684zM5.733 2.043l-1.57 1.56l1.058 1.064l1.57-1.56zm4.458 5.44c-.53-.532-.53-.532-.53-.53h-.002l-.003.004a1 1 0 0 0-.127.157c-.054.08-.113.185-.163.318a2.1 2.1 0 0 0-.088 1.071c.134.865.73 2.008 2.256 3.526l1.058-1.064c-1.429-1.42-1.769-2.284-1.832-2.692c-.03-.194.001-.29.01-.312q.009-.02 0-.006a.3.3 0 0 1-.03.039l-.01.01l-.01.009zm1.343 4.546c1.527 1.518 2.676 2.11 3.542 2.242c.443.068.8.014 1.071-.087a1.5 1.5 0 0 0 .42-.236l.05-.045l.007-.006l.003-.003l.001-.002s.002-.001-.527-.533c-.53-.532-.528-.533-.528-.533l.002-.002l.002-.002l.006-.005l.01-.01l.038-.03q.014-.009-.007.002c-.025.009-.123.04-.32.01c-.414-.064-1.284-.404-2.712-1.824zm-1.56-9.62C8.954 1.049 6.95.834 5.733 2.044L6.79 3.107c.532-.529 1.476-.475 1.983.202zM4.752 5.704c-.02-.346.139-.708.469-1.036L4.163 3.604c-.537.534-.96 1.29-.909 2.184zm14.72 12.06c-.274.274-.57.428-.865.455l.139 1.494c.735-.069 1.336-.44 1.784-.885zM11.006 7.73c.985-.979 1.058-2.527.229-3.635l-1.201.899c.403.539.343 1.246-.085 1.673zm9.52 6.558c.817.444.944 1.49.367 2.064l1.058 1.064c1.34-1.333.927-3.557-.71-4.446zm-3.441-.849c.384-.382 1.002-.476 1.53-.19l.716-1.317c-1.084-.59-2.428-.427-3.304.443z"/></svg>
                    </span>{{ item.phone }}</div>
                </td>

                <td>{{ item.plan }}</td>

                <td>{{ item.tier }}</td>

                <td>{{ item.rep }}</td>

                <td>
                  <span :class="['badges', item.paymentStatus ? item.paymentStatus.toLowerCase().replace(/\s+/g, '-') : 'unpaid']">
                    <span class="icon">
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24"><g fill="currentColor"><path d="M12 6a1 1 0 0 1 1 1v6a1 1 0 1 1-2 0V7a1 1 0 0 1 1-1m0 10a1 1 0 1 0 0 2a1 1 0 0 0 0-2"/><path fill-rule="evenodd" d="M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10s10-4.477 10-10S17.523 2 12 2M4 12a8 8 0 1 0 16 0a8 8 0 0 0-16 0" clip-rule="evenodd"/></g></svg>
                    </span>
                    {{ item.paymentStatus || 'Unpaid' }}</span>
                </td>

                <td>{{ item.reason }}</td>

                <td class="fw-semibold">{{ item.premium }}</td>
              </tr>

              <tr v-if="!loading && invoices.length === 0">
                <td colspan="10" class="text-center">No invoice data found</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Api from "@/resource/Api.js";
import QuickDropdownFilter from "../../components/ui/QuickDropdownFilter.vue";
import IhaPagination from "../../components/ui/IhaPagination.vue";

import "./memberinvoiceinsight.css";

export default {
  components: {
    QuickDropdownFilter,
    IhaPagination,
  },

  data() {
    return {
      breadcrumbItems: [{ title: "Member Invoice Insights", active: true }],
      search: "",
      datefilterType: "Last 1 Month",
      dateOptions: ["Last 1 Month", "Last 2 Months", "Last 3 Months"],
      invoices: [],
      paginationMeta: {},
      totalPremium: "",
      loading: false,
      currentPage: 1,
      perPage: 10,
      searchTimeout: null,
    };
  },

  computed: {
    agentId() {
      return this.$store.getters.repId;
    },
    months() {
      const map = { "Last 1 Month": 1, "Last 2 Months": 2, "Last 3 Months": 3};
      return map[this.datefilterType] ?? 1;
    },
  },

  mounted() {
    this.fetchInvoices();
  },

  watch: {
    search() {
      clearTimeout(this.searchTimeout);
      this.searchTimeout = setTimeout(() => {
        this.currentPage = 1;
        this.fetchInvoices();
      }, 400);
    },
    datefilterType() {
      this.currentPage = 1;
      this.fetchInvoices();
    },
  },

  methods: {
    fetchInvoices() {
      this.loading = true;
      const params = new URLSearchParams({
        months: this.months,
        per_page: this.perPage,
        page: this.currentPage,
        agent_id: this.agentId,
      });
      if (this.search) {
        params.set("rep", this.search);
      }
      const url = `v2/commission/unpaid-invoices?${params.toString()}`;
      Api.get(url)
        .then((res) => {
          const data = res.data.data;
          this.paginationMeta = {
            total: data.total,
            per_page: data.per_page,
            current_page: data.current_page,
            last_page: data.last_page,
            from: data.from,
            to: data.to,
          };
          this.totalPremium = data.total_premium || "";
          this.invoices = (data.data || []).map((item) => ({
            systemId: item.system_id,
            effectiveDate: item.effective_date,
            invoiceMonth: item.invoice_details?.label || "",
            billDate: (item.invoice_details?.bill_date || "").replace("Bill date: ", ""),
            member: item.primary_member?.name || "",
            email: item.primary_member?.email || "",
            phone: item.primary_member?.phone || "",
            plan: item.plan,
            tier: item.tier,
            rep: item.rep,
            paymentStatus: item.payment_status,
            reason: item.reason,
            premium: item.premium,
          }));
        })
        .catch(() => {
          this.invoices = [];
          this.paginationMeta = {};
        })
        .finally(() => {
          this.loading = false;
        });
    },

    handlePageChange({ page, pageSize }) {
      this.currentPage = page;
      this.perPage = pageSize;
      this.fetchInvoices();
    },

    clearFilters() {
      this.search = "";
      this.datefilterType = "Last 1 Month";
    },
  },
};
</script>

<style scoped>
.skeleton-row td {
  padding-top: 12px;
  padding-bottom: 12px;
}

.skeleton-cell {
  display: block;
  height: 13px;
  border-radius: 6px;
  background: linear-gradient(90deg, #e8e8e8 25%, #f5f5f5 50%, #e8e8e8 75%);
  background-size: 200% 100%;
  animation: shimmer 1.4s infinite;
}

.skeleton-cell.mt-1 {
  margin-top: 6px;
}

@keyframes shimmer {
  0%   { background-position: 200% 0; }
  100% { background-position: -200% 0; }
}
</style>
